import { BaseEntity } from '../base-entity';
import { DatasetAccess } from './dataset-access';
import { OrganisationWorkspace } from './organisation-workspace';
import { PbiDataset } from './pbi-dataset';
import { Report } from './report';

/// <code-import> Place custom imports between <code-import> tags
import { EntityName } from '@mri-platform/dsg/core';
import { AuthzContextsActionMap } from '@mri-platform/resource-authz';
import { AutoGeneratedKeyType, MetadataStore } from 'breeze-client';
/// </code-import>

export interface Dataset {
  id: string;
  category?: string;
  hasStandardRlsRoles: boolean;
  isDeleted: boolean;
  isFromClientTemplate: boolean;
  lastSuccessfulRefreshAt?: Date;
  lastUpdatedBy: string;
  lastUpdatedDate: Date;
  moduleName?: string;
  name: string;
  organisationWorkspaceId: string;
  periodEnd: Date;
  periodStart: Date;
  region?: string;
  templateDatasetName: string;
  tenantKey: string;
  allowedPrincipals: DatasetAccess[];
  organisationWorkspace: OrganisationWorkspace;
  pbiDatasets: PbiDataset[];
  reports: Report[];
}

/// <module-code> Place module level code between <module-code> tags
const typeFuncs = BaseEntity.makeStaticTypeFunctions<Dataset>(EntityName.Dataset);
/// </module-code>

export class Dataset extends BaseEntity {
  /// <code> Place custom code between <code> tags
  static readonly authorization = AuthzContextsActionMap.crudFor(EntityName.Dataset);
  static readonly propName = typeFuncs.propName;

  static register(metadataStore: MetadataStore) {
    // The metadata `autoGeneratedKeyType` generated from the EF Core model is 'Identity' but Dataset.Id is a GUID,
    // not a server-generated integer. Setting it to 'None' so Breeze correctly materialises entities from
    // the live server and the `instanceof Dataset` check in canSave() works as expected.
    const et = metadataStore.getAsEntityType('Dataset', false);
    et.setProperties({ autoGeneratedKeyType: AutoGeneratedKeyType.None });
  }

  description?: string;
  /// </code>
  // Generated code. Do not place code below this line.
}
